import { render, staticRenderFns } from "./WorkPermitSafety.vue?vue&type=template&id=91a0d4b2&scoped=true"
import script from "./WorkPermitSafety.vue?vue&type=script&lang=js"
export * from "./WorkPermitSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a0d4b2",
  null
  
)

export default component.exports